import { render, staticRenderFns } from "./DachCampaign.vue?vue&type=template&id=6ba697d2"
import script from "./DachCampaign.vue?vue&type=script&setup=true&lang=ts"
export * from "./DachCampaign.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports